import DiscountCostPoolExamine from './discount_examine.vue';

export default DiscountCostPoolExamine;
